export default [
  {
    text: 'Villa Shaila',
    lat: 42.7343743,
    lng: 16.8854005
  },
  {
    text: 'Villa Tapenade',
    lat: 42.7325824,
    lng: 16.8851439
  },
  {
    text: 'Augusta Insula',
    lat: 42.7720102,
    lng: 16.8755016
  }
]



// WEBPACK FOOTER //
// ./src/data/googleMapLocations.js